export let content = {
    English: {
      home:"Home",
      services:"Services",
      about:"About Us",
      gallery:"Gallery",
      testi:"Testimonial",
      contactus:"Contact Us",
      email:"Request Form"
    },  
    Indonesia:{
      home:"Home",
      services:"Services",
      about:"About Us",
      gallery:"Gallery",
      testi:"Testimoni / Kata Mereka",
      contactus:"Contact Us",
      email:"Request Form"
    }
  };